import {useLocation} from 'react-router-dom';
import {parseQueryToFilters} from '../infrastructure/filterUrlMapper';

export function useInitialFilters() {
    const location = useLocation();
    return parseQueryToFilters(new URLSearchParams(location.search));
}